import PropTypes from 'prop-types';
import { KeycloakAuthProvider } from '../../../@lbs/context/KeyCloakAuthProvider';

const AppAuthProvider = ({ children }) => {
  return <KeycloakAuthProvider>{children}</KeycloakAuthProvider>;
};

AppAuthProvider.propTypes = {
  children: PropTypes.node,
};
export default AppAuthProvider;
